/**
 * Storefront money helpers.
 *
 * Shopify.money_format is the *presentment* format for the active market
 * (Rs. {{amount}}, €{{amount_with_comma_separator}}, …). Parse and format
 * through this file so Algolia and Shoplift-derived prices do not hardcode $.
 *
 * parseMoney maps a rendered price string back to Shopify's integer subunits
 * (always hundredths, even for JPY/KRW no-decimal displays).
 */
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /{{\s*(\w+)\s*}}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        centsPart = parts[1] ? (decimal + parts[1]) : '';
    return dollars + centsPart;
  }
  var placeholderMatch = String(formatString).match(placeholderRegex);
  var placeholder = placeholderMatch ? placeholderMatch[1] : 'amount';
  switch (placeholder) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
      break;
    case 'amount_no_decimals_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 0, "'", '.');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }
  return formatString.replace(placeholderRegex, value);
};

Shopify.parseMoney = function(text, format) {
  if (text == null || text === '') return null;
  var formatString = format || this.money_format || '${{amount}}';
  var placeholderRegex = /{{\s*(\w+)\s*}}/;
  var strippedFormat = String(formatString).replace(/<[^>]*>/g, '');
  var match = strippedFormat.match(placeholderRegex);
  var placeholder = match ? match[1] : 'amount';
  var prefix = '';
  var suffix = '';
  if (match) {
    prefix = strippedFormat.slice(0, match.index).replace(/\u00a0/g, ' ');
    suffix = strippedFormat.slice(match.index + match[0].length).replace(/\u00a0/g, ' ');
  }
  var s = String(text).replace(/<[^>]*>/g, '').replace(/\u00a0/g, ' ');
  if (prefix) {
    if (s.indexOf(prefix) === 0) {
      s = s.slice(prefix.length);
    } else {
      var prefixTrim = prefix.replace(/\s+$/, '');
      if (prefixTrim && s.indexOf(prefixTrim) === 0) s = s.slice(prefixTrim.length);
    }
  }
  if (suffix) {
    if (suffix && s.length >= suffix.length && s.slice(-suffix.length) === suffix) {
      s = s.slice(0, s.length - suffix.length);
    } else {
      var suffixTrim = suffix.replace(/^\s+/, '');
      if (suffixTrim && s.slice(-suffixTrim.length) === suffixTrim) {
        s = s.slice(0, s.length - suffixTrim.length);
      }
    }
  }
  s = s.replace(/^\s+|\s+$/g, '');

  var thousands = ',';
  var decimal = '.';
  switch (placeholder) {
    case 'amount_with_comma_separator':
    case 'amount_no_decimals_with_comma_separator':
      thousands = '.';
      decimal = ',';
      break;
    case 'amount_with_space_separator':
    case 'amount_no_decimals_with_space_separator':
      thousands = ' ';
      decimal = ',';
      break;
    case 'amount_with_apostrophe_separator':
    case 'amount_no_decimals_with_apostrophe_separator':
      thousands = "'";
      decimal = '.';
      break;
  }

  if (thousands === ' ') {
    s = s.replace(/\s/g, '');
  } else {
    var escaped = thousands.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    s = s.replace(new RegExp(escaped, 'g'), '');
  }
  if (decimal !== '.') s = s.replace(decimal, '.');
  s = s.replace(/[^\d.]/g, '');
  if (!s) return null;
  var n = parseFloat(s);
  if (isNaN(n)) return null;
  return Math.round(n * 100);
};

/**
 * Format a shop-currency major-unit amount (Algolia `price` / `variants_min_price`)
 * into the active presentment money_format.
 *
 * Uses Shopify.currency.rate. Markets price lists can still diverge from that
 * rate — this is for search cards, not a replacement for Liquid `| money`.
 */
Shopify.formatPresentmentPrice = function(shopAmount) {
  var n = parseFloat(shopAmount);
  if (isNaN(n)) return '';
  var rate = 1;
  if (this.currency && this.currency.rate) {
    var parsedRate = parseFloat(this.currency.rate);
    if (!isNaN(parsedRate) && parsedRate > 0) rate = parsedRate;
  }
  var cents = Math.round(n * 100 * rate);
  var formatted = this.formatMoney(cents, this.money_format);
  return String(formatted).replace(/<[^>]*>/g, '');
};
